import { Component, input, OnInit, inject, signal } from '@angular/core';

import { Photo } from '../order.model';
import { PhotoService } from '../photo.service';
import { PhotoViewer } from '../photo-viewer/photo-viewer';

@Component({
  selector: 'app-photo-preview',
  standalone: true,
  imports: [PhotoViewer],
  templateUrl: './photo-preview.html',
  styleUrl: './photo-preview.css'
})
export class PhotoPreview implements OnInit {
  photos = input.required<Photo[]>();
  // Tiles show the thumbnail; the viewer fetches the full-resolution image on demand.
  previews: { blobName: string; thumbUrl: string | null }[] = [];
  loading = true;

  // Index in photos() of the photo open in the viewer, or null when it's closed.
  viewerIndex = signal<number | null>(null);

  private photoService = inject(PhotoService);

  ngOnInit() {
    // Just do initial loading once
    this.loadPhotos();
  }

  // When photos input changes, this gets called
  private loadPhotos(): void {
    const photoList = this.photos();
    if (!photoList || photoList.length === 0) {
      this.previews = [];
      this.loading = false;
      return;
    }

    this.loading = true;

    // Take first 4 photos only
    const photosToLoad = photoList.slice(0, 4);

    Promise.all(
      photosToLoad.map(photo =>
        this.photoService.getThumbnailUrl(photo)
          .then(thumbUrl => ({ blobName: photo.blobName, thumbUrl }))
          .catch(error => {
            console.error("Failed to load thumbnail:", photo.blobName, error);
            return { blobName: photo.blobName, thumbUrl: null };
          })
      )
    ).then(previews => {
      this.previews = previews;
      this.loading = false;
    }).catch(error => {
      console.error('Error loading photos:', error);
      this.loading = false;
    });
  }
}